module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-og-image-c41e4ffb7cc6b134a496bfea15eeb60e.jpg";